import React from 'react'

import { Chip, Box } from '@mui/material'
import { LocalPhone, AlternateEmail, Room } from '@mui/icons-material'

const CompanyInfo = ({ email, gsm, address, ...props }) => (
  <Box sx={{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2
  }}
  >
    {!!gsm && <Chip icon={<LocalPhone />} color="primary" label={gsm} variant="outlined" size="small" />}
    {!!email && <Chip icon={<AlternateEmail />} color="primary" label={email} variant="outlined" size="small" />}
    {!!address && <Chip icon={<Room />} color="primary" label={address} variant="outlined" size="small" />}
  </Box>
)




export default React.memo(CompanyInfo)
